import { vstsAccessService } from "services/vstsaccess.service";

export const handleVstsButton = (e) => {
    e.stopPropagation();
    var windowReference = window.open();
    windowReference.opener = null;
    windowReference.location = process.env.REACT_APP_VSTS
    vstsAccessService.getVstsAccess().then(() => {})
    .catch((error) => {
      console.error("Error getting VSTS access", error);
    });
  }